import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { toggleTaskStatus } from "../functions/notifications/toggleTaskStatus";
import { deleteNotification } from "../functions/notifications/deleteNotification";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export const notificationsListModal = ({
  t,
  windowValues,
  setWindowValues,
  setModalData,
  setModalData2,
  setMsg2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  const writeMessage = (e: stdObject) => {
    // console.log("e", e);
    const msg =
      e.BODTA0 !== ""
        ? e.BODTA0
        : windowValues?.models?.find((v: stdObject) => v.IDTAS === e.NUMTA0)
            .MSGTAS;
    return msg.replace(/\{\{(\w+)\}\}/g, (match: string, key: string) =>
      key === "DOC" ? t("c." + e.DOCTA0) : (e.DATA?.[key] ?? match),
    );
  };
  return "notifications" in windowValues
    ? {
        title: t("c.ALA"),
        mainColor: colors.blue,
        blocked: true,
        //inputListStyle: { height: 300 },
        table: windowValues.notifications.map((e: stdObject, index: number) => {
          return {
            data: [
              { text: writeMessage(e), style: { whiteSpace: "pre-line" } },
              {
                type: "icon",
                Icon: e.TIPTA0
                  ? DeleteForeverIcon
                  : e.ESTTA0
                    ? CheckBoxIcon
                    : CheckBoxOutlineBlankIcon,
                color: e.TIPTA0
                  ? colors.red
                  : e.ESTTA0
                    ? colors.green
                    : colors.grey,
                onClick: () =>
                  e.TIPTA0 === 1
                    ? deleteNotification(false, {
                        t,
                        notification: e,
                        index,
                        windowValues,
                        setWindowValues,
                        setModalData2,
                        setMsg2,
                        closeMsg,
                        logoutAction,
                      })
                    : toggleTaskStatus(e, index, {
                        windowValues,
                        setWindowValues,
                        logoutAction,
                      }),
                //color={data.color}
                //style={data.style ?? {}}
              },
            ],
            style: {
              backgroundColor:
                index % 2 === 0 ? colors.lightGrey : colors.white,
            },
          };
        }),
        buttons: [
          {
            label: t("p.close"),
            onClick: () => {
              closeMsg();
              setModalData({});
            },
            color: colors.darkGrey,
          },
        ],
      }
    : {};
};
